import React, { Component, PureComponent } from 'react';
import './styles/Map.css';
import { prodMapTile } from '../configs/config';
import { dataByCountryCode } from '../configs/byCCode';
import { dataWithNoID } from '../configs/byNoIden';
import { dataBySlug } from '../configs/bySlug';
import { usStates } from '../configs/UsStates';
import {  byCountryName } from '../configs/byCountryName';
import { flags } from '../configs/flags';

import Loader from './Loader';
import GlobalView from './GlobalView';
import Tutorial from './Tutorial';
import About from './About';
import SidePanel from './SidePanel';

import './styles/MobileView.css';

const baseReverseGeocoderURL = "https://services.gisgraphy.com/reversegeocoding/search?";
const geoNamesAlternativeBaseURL = 'http://api.geonames.org/countryCode?';
const nominatimBasURL = "https://nominatim.openstreetmap.org/reverse?format=json&";

// https://nominatim.openstreetmap.org/reverse?format=json&lat=52.5487429714954&lon=13.3978343993255

// http://api.geonames.org/countryCode?lat=47.03&lng=10.2&username=covidtracker

// https://services.gisgraphy.com/reversegeocoding/search?format=json&lat=48.8723789988&lng=2.2996401787&from=1&to=10

const globalDataSummaryURL = "https://api.covid19api.com/summary";
//GET data after date with country, and isoDate example
//https://api.covid19api.com/live/country/united-states/status/confirmed/date/2020-04-11T00:00:30Z


// let WE = window.WE;
let WE = null;
// let WebGLEarth = window.WebGLEarth;
let earth;
let cbnds = null;
let key = 0;
let pauseAnime = false;


export default class Map extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            centre: { long: 0, lat: 7 },
            zoom: window.screen.width < 768 ? 1.8 : 2.8,
            alt: 7000000,
            atmosphere: true,
            showStars: false,
            minAlt: 100000,
            // maxAlt: 2000000000000000,
            maxAlt: 19000000,
            // maxAlt: 12000000,
            dragging: true,
            tilting: false,
            zooming: true,
            scrollWheelZoom: true,
            unconstrainedRotation: false,
            globeLoaded: false,
            allDataLoaded: false,
            markerData: null,
            countryTotal: null,
            curLoadedCountry: null,
            searchVal: null,
            searchScope: null,
        }

        this.decideClickOrDrag = this.decideClickOrDrag.bind(this);
        this.focusViewToCoord = this.focusViewToCoord.bind(this);


        Date.prototype.toIsoString = function() {
            // console.log('new timezone');
            var tzo = -this.getTimezoneOffset(),
                dif = tzo >= 0 ? '+' : '-',
                pad = function(num) {
                    var norm = Math.floor(Math.abs(num));
                    return (norm < 10 ? '0' : '') + norm;
                };
            return this.getFullYear() +
                '-' + pad(this.getMonth() + 1) +
                '-' + pad(this.getDate()) +
                'T' + pad(this.getHours()) +
                ':' + pad(this.getMinutes()) +
                ':' + pad(this.getSeconds()) +
                dif + pad(tzo / 60) +
                ':' + pad(tzo % 60);
        }


    }



    componentWillMount() {
        if(sessionStorage.getItem('GlobalTotalCount') 
        && sessionStorage.getItem('CountriesTotalCount') 
        && sessionStorage.getItem('CountrySpecificData')) {
            // console.log('good');
            return;
        }
        else {
            this.getGlobalTotalCaseData();
            this.getCountriesData();
        }
    }
    
    componentDidMount () {
        this.initialise();
        if(!sessionStorage.getItem('GlobalTotalCount') && !sessionStorage.getItem('CountriesTotalCount') && !sessionStorage.getItem('CountrySpecificData')) {
            const interval2 = setInterval(() => {
                if(sessionStorage.getItem('GlobalTotalCount') && sessionStorage.getItem('CountriesTotalCount') && sessionStorage.getItem('CountrySpecificData')) {
                    clearInterval(interval2);
                    this.setState({
                        markerData: JSON.parse(sessionStorage.getItem('CountrySpecificData')),
                        countryTotal: JSON.parse(sessionStorage.getItem('CountriesTotalCount'))
                    }, () => {
                        this.placeAllMarkers();
                        this.makerMarkerCircle();
                        this.setState({
                            allDataLoaded: true
                        }, () => {
                            setTimeout(() => {
                                this.updateData();
                            }, 4000)
                        })
                    })
                }
            }, 1000);
            return () => clearInterval(interval2);
        }
        else {
            this.setState({
                markerData: JSON.parse(sessionStorage.getItem('CountrySpecificData')),
                countryTotal: JSON.parse(sessionStorage.getItem('CountriesTotalCount'))
            }, () => {
                this.placeAllMarkers();
                this.makerMarkerCircle();
                setTimeout(() => {
                    this.setState({
                        allDataLoaded: true
                    }, () => {
                        this.updateData();
                    })
                }, 6000)
            })
        }
    }

    getGlobalTotalCaseData = () => {
        let globalTotal;
        let countryTotalList;
        let compute = new Promise((resolve, reject) => {
            fetch(globalDataSummaryURL)
            .then(response => {
                if(response.ok) {
                    return response.json();
                }
                else {
                    throw new Error('Global summary api error');
                }
            })
            .then(data => {
                globalTotal = data.Global;
                // console.log(globalTotal);
                countryTotalList = {};
                data.Countries.forEach(element => {
                    countryTotalList[element.Slug] = {...element}
                }, resolve('done'));
                
            })
            .catch(err => {
                let er = err;
            })
        })

        Promise.all([compute])
        .then(() => {
            sessionStorage.setItem('GlobalTotalCount', JSON.stringify(globalTotal));
            sessionStorage.setItem('CountriesTotalCount', JSON.stringify(countryTotalList));
            return true;
        })
    }

    getCountriesData = async () => {
        let dateYesterday = new Date();
        dateYesterday.setDate(dateYesterday.getDate()-1);
        dateYesterday = dateYesterday.toISOString();
        dateYesterday = dateYesterday.slice(0, dateYesterday.indexOf('T')+1)+"00:00:00.000Z";
        let today = new Date().toISOString();
        today = today.slice(0,today.indexOf('T')+1)+"00:00:00.000Z";


        let test = await fetch(`https://api.covid19api.com/country/south-africa?from=${dateYesterday}&to=${today}`)
        .then(res => {
            if(res.ok) {
                return res.json();
            }
            else {
                throw new Error('Problem getting all country data');
            }
        })
        .then((data) => {
            return data;
        })
        .catch(err => {
            let er = err;
        });

        let CountrySpecificData = [];
        if(test.length > 0) {
            let compute = await new Promise((resolve, reject) => {
                for(let sl in dataBySlug) {
                    if(sl === "zimbabwe") {
                        resolve('done');
                    }
                    if(sl === "china" || sl === "united-kingdom" || sl === "france" || sl === "canada" || sl === "australia") {
                        let elem = dataBySlug[sl];
                        fetch(`https://api.covid19api.com/country/${elem.slug}?from=${dateYesterday}&to=${today}`)
                        .then(res => {
                            if(res.ok) {
                                return res.json();
                            }
                            else {
                                throw new Error('Problem getting api data for ', elem.slug);
                            }
                        })
                        .then((data) => {
                            if(sl === "zimbabwe") {
                                resolve('done');
                                // setTimeout(() => {
                                //     resolve('done');
                                // }, 3000)
                            }
        
                            CountrySpecificData.push(...data);
                            
                        })
                        .catch(err => {
                            // console.log(err);
                            let er = err;
                        })
                    }
                }
            });
    
            let computeUs = await new Promise((resolve, reject) => {
                fetch(`https://api.covid19api.com/country/united-states?from=${dateYesterday}&to=${today}`)
                .then(res => {
                    if(res.ok) {
                        return res.json();
                    }
                    else {
                        throw new Error('Problem getting api data for united-states');
                    }
                })
                .then((data) => {
                    function combineBy(objArr, property) {
                        return objArr.reduce(function(acc, obj) {
                            let state = obj[property];
                            if(!acc[state]) {
                                if(!usStates[state]) {
                                    acc[state] = {};
                                }
                                else {
                                    acc[state] = {...usStates[state]};
                                }
                            }
                            if(Object.keys(acc[state]).length === 0) {
                                acc[state] = {...obj};
                            }
                            else {
                                acc[state] = {...acc[state], Active: acc[state]['Active']+obj['Active'],
                                Deaths: acc[state]['Deaths']+obj['Deaths'], Confirmed: acc[state]['Confirmed']+obj['Confirmed'],
                                Recovered: acc[state]['Recovered']+obj['Recovered']};
                            }
                            return acc
                        }, {})
                    }
    
                    let combined =  combineBy(data, "Province");
                    let dataToPush = Object.values(combined);
    
                    CountrySpecificData = CountrySpecificData.concat(dataToPush);
                    resolve('done');
                })
            });

            let computeOthers = await new Promise((resolve, reject) => {
                fetch(globalDataSummaryURL)
                .then(response => {
                    if(response.ok) {
                        return response.json();
                    }
                    else {
                        throw new Error('Country Specific data stringing error');
                    }
                })
                .then((data) => {
                    let tempArr7 = [];
                    let dataInfo = data.Countries;
                    let tempObj7 = {};
                    for(let i = 0; i < dataInfo.length; i++) {
                        let element = dataInfo[i];
                        if(dataBySlug[element.Slug]) {
                            tempObj7 = {
                                Active: element.TotalConfirmed-(element.TotalRecovered+element.TotalDeaths),
                                City: "",
                                CityCode: "",
                                Confirmed: element.TotalConfirmed,
                                Country: element.Country,
                                CountryCode: element.CountryCode,
                                Date: element.Date,
                                Deaths: element.TotalDeaths,
                                Lat: dataBySlug[element.Slug].latitude,
                                Lon: dataBySlug[element.Slug].longitude,
                                Recovered: element.TotalRecovered,
                                Province: ""
                            };
                            tempArr7 = [...tempArr7, tempObj7];
                        }
                    }

                    // console.log(tempArr7);
                    CountrySpecificData = CountrySpecificData.concat(tempArr7);
                    resolve("done");
                })
            });

            Promise.all([compute, computeUs, computeOthers])
            .then(() => {
                sessionStorage.setItem('CountrySpecificData', JSON.stringify(CountrySpecificData));
            })
        }
        else {
            today = dateYesterday;
            dateYesterday = new Date();
            dateYesterday.setDate(dateYesterday.getDate()-2);
            dateYesterday = dateYesterday.toISOString();
            dateYesterday = dateYesterday.slice(0, dateYesterday.indexOf('T')+1)+"00:00:00.000Z";


            let compute = await new Promise((resolve, reject) => {
                for(let sl in dataBySlug) {
                    if(sl === "zimbabwe") {
                        resolve('done');
                    }
                    if(sl === "china" || sl === "united-kingdom" || sl === "france" || sl === "canada" || sl === "australia") {
                        let elem = dataBySlug[sl];
                        fetch(`https://api.covid19api.com/country/${elem.slug}?from=${dateYesterday}&to=${today}`)
                        .then(res => {
                            if(res.ok) {
                                return res.json();
                            }
                            else {
                                throw new Error('Problem getting api data for ', elem.slug);
                            }
                        })
                        .then((data) => {
                            if(sl === "zimbabwe") {
                                resolve('done');
                                // setTimeout(() => {
                                //     resolve('done');
                                // }, 3000)
                            }
        
                            CountrySpecificData.push(...data);
                            
                        })
                        .catch(err => {
                            // console.log(err);
                            let er = err;
                        })
                    }
                }
            });
    
            let computeUs = await new Promise((resolve, reject) => {
                fetch(`https://api.covid19api.com/country/united-states?from=${dateYesterday}&to=${today}`)
                .then(res => {
                    if(res.ok) {
                        return res.json();
                    }
                    else {
                        throw new Error('Problem getting api data for united-states');
                    }
                })
                .then((data) => {
                    function combineBy(objArr, property) {
                        return objArr.reduce(function(acc, obj) {
                            let state = obj[property];
                            if(!acc[state]) {
                                if(!usStates[state]) {
                                    acc[state] = {};
                                }
                                else {
                                    acc[state] = {...usStates[state]};
                                }
                            }
                            if(Object.keys(acc[state]).length === 0) {
                                acc[state] = {...obj};
                            }
                            else {
                                acc[state] = {...acc[state], Active: acc[state]['Active']+obj['Active'],
                                Deaths: acc[state]['Deaths']+obj['Deaths'], Confirmed: acc[state]['Confirmed']+obj['Confirmed'],
                                Recovered: acc[state]['Recovered']+obj['Recovered']};
                            }
                            return acc
                        }, {})
                    }
    
                    let combined =  combineBy(data, "Province");
                    let dataToPush = Object.values(combined);
    
                    CountrySpecificData = CountrySpecificData.concat(dataToPush);
                    resolve('done');
                })
            });

            let computeOthers = await new Promise((resolve, reject) => {
                fetch(globalDataSummaryURL)
                .then(response => {
                    if(response.ok) {
                        return response.json();
                    }
                    else {
                        throw new Error('Country Specific data stringing error');
                    }
                })
                .then((data) => {
                    let tempArr7 = [];
                    let dataInfo = data.Countries;
                    let tempObj7 = {};
                    for(let i = 0; i < dataInfo.length; i++) {
                        let element = dataInfo[i];
                        if(dataBySlug[element.Slug]) {
                            tempObj7 = {
                                Active: element.TotalConfirmed-(element.TotalRecovered+element.TotalDeaths),
                                City: "",
                                CityCode: "",
                                Confirmed: element.TotalConfirmed,
                                Country: element.Country,
                                CountryCode: element.CountryCode,
                                Date: element.Date,
                                Deaths: element.TotalDeaths,
                                Lat: dataBySlug[element.Slug].latitude,
                                Lon: dataBySlug[element.Slug].longitude,
                                Recovered: element.TotalRecovered,
                                Province: ""
                            };
                            tempArr7 = [...tempArr7, tempObj7];
                        }
                    }

                    // console.log(tempArr7);
                    CountrySpecificData = CountrySpecificData.concat(tempArr7);
                    resolve("done");
                })
            });

            Promise.all([compute, computeUs, computeOthers])
            .then(() => {
                sessionStorage.setItem('CountrySpecificData', JSON.stringify(CountrySpecificData));
            })
        }


    }

    clearMarkers = () => {
       
        let children = document.getElementsByClassName('iconParent');
        for(let i = 0; i < children.length; i++) {
            children[i].parentNode.removeChild(children[i]);
        }
    }

    updateData = () => {
        const interval3 = setInterval(() => {
            let req1 = this.getGlobalTotalCaseData();
            let req2 = this.getCountriesData();

            Promise.all([req1, req2])
            .then((vals) => {
                setTimeout(() => {
                    this.setState({
                        markerData: JSON.parse(sessionStorage.getItem('CountrySpecificData'))
                    }, () => {
                      
                    })
                }, 4000)
            });
        }, 600000);
        return () => clearInterval(interval3);
    }

    initialise = () => {
        WE = window.WE;
        let focus = [this.state.centre.lat, this.state.centre.long];
        let options = {
            center: focus,
            zoom: this.state.zoom,
            altitude: this.state.alt,
            atmosphere: this.state.atmosphere,
            sky: this.state.showStars,
            minAltitude: this.state.minAlt,
            maxAltitude: this.state.maxAlt,
            dragging: this.state.dragging,
            tilting: this.state.tilting,
            zooming: this.state.zooming,
            scrollWheelZoom: this.state.scrollWheelZoom,
            unconstrainedRotation: this.state.unconstrainedRotation
        };


        earth = new WE.map('earth_div', options);
        WE.tileLayer(prodMapTile, {maxZoom: 8}).addTo(earth);

        earth.setView([this.state.centre.lat, this.state.centre.long]);
        earth.setTilt(0);
        this.setState({
            globeLoaded: true,
        }, () => { 
            cbnds = earth.getBounds();
            earth.offAll('click');
            return;
        });
        
       
    }

    anime = () => {
        let before = null;
        function doNothing(){
            return;
        }
        requestAnimationFrame(function animate(now) {
            let c = earth.getPosition();
            let elapsed = before? now - before: 0;
            before = now;
            earth.setCenter([c[0], c[1] + 0.1*(elapsed/30)]);
            if(pauseAnime) {
                return;
            }
            else {
                requestAnimationFrame(animate)
            }
        });
    }
    
    decideClickOrDrag = (event) => {
        event.preventDefault();
        
        let coord = [event.latitude, event.longitude];

        let curBounds = earth.getBounds();

        let isDrag;

        if(curBounds !== null && curBounds !== undefined) {
            isDrag = Math.abs(curBounds[0] - cbnds[0]) >=.5 || Math.abs(curBounds[1] - cbnds[1]) >=.5
                    || Math.abs(curBounds[2] - cbnds[2]) >=.5 || Math.abs(curBounds[3] - cbnds[3]) >=.5;
        }
        earth.off(key);
        
        

        return [isDrag, coord];

    }

    listenForMouseEvent = (decider, focuser) => {
        if(this.state.globeLoaded) {
            earth.offAll();
            earth.setTilt(0);
            cbnds = earth.getBounds();
            earth.on('click', checker);
        }

        function checker(event) {
            let decision = decider(event);
           

            if(!decision[0]) {
                focuser(decision[1], false, true);
            }

            cbnds = earth.getBounds();
            return;
        }

        key = this.state.globeLoaded ? earth.on('click', checker) : 0;
        
        return;
    }

    focusViewToCoord = async (coords, shouldPan, shouldSet) => {
        let url = nominatimBasURL + `lat=${coords[0]}&lon=${coords[1]}`;

        await fetch(url)
        .then((response) => {
            if(response.ok) {
                return response.json();
            }
            else {
                throw new Error("Getting country code error.");
            }
        })
        .then((data) => {
            if(!data.error) {
                let cc = data.address.country_code.toUpperCase();
                if(cc !== null || cc !== undefined) {
                    this.setCurCountry(cc);
                    this.centralise(cc, shouldPan, shouldSet);
                    return;
                }
            }
        })
        .catch((err) => {
            // console.log(err);
            let er = err;
            cbnds = earth.getBounds();
            return;
        })
    }

    setCurCountry = (cc) => {
        let slug = this.getSlugFromCC(cc);
        this.setState({
            curLoadedCountry: this.state.countryTotal[slug]
        });
        return;
    }

    getSlugFromCC = (cc) => {
        let sl = dataByCountryCode[cc].slug;
        return sl;
    }

    centralise = (countryCode, shouldPan, shouldSet) => {
        let centre = [dataByCountryCode[countryCode].latitude, dataByCountryCode[countryCode].longitude];
        if(shouldPan) {
            earth.panTo(centre, {duration: 100});
            return;
        }
        if(shouldSet) {
            earth.setView(centre, 4.5);
            return;
        }
        return;
    }

    updateBoundsVariable = () => {
        const interval = setInterval(() => {
            cbnds = this.state.globeLoaded ? earth.getBounds() : null;
        }, 500);
        return () => clearInterval(interval);
    }

    placeAllMarkers = () => {
        if(this.state.globeLoaded) {
            for(let i = 0; i < this.state.markerData.length; i++) {
                if(this.state.markerData[i] && this.state.markerData[i] !== null) {
                    let curMarker = WE.marker([Number(this.state.markerData[i].Lat), Number(this.state.markerData[i].Lon)]).addTo(earth);
                    let countryName = this.state.markerData[i].Country;
                    let countryCode = this.state.markerData[i].CountryCode;
                    let flag = flags[this.state.markerData[i].CountryCode] ? flags[this.state.markerData[i].CountryCode].url : '';
                    let province = this.state.markerData[i].Province === "" ? "" : this.state.markerData[i].Province + ", ";
                    let city = this.state.markerData[i].City === "" ? "" : this.state.markerData[i].City + ", ";
                    let conf = this.state.markerData[i].Confirmed;
                    let active = this.state.markerData[i].Active;
                    // let recover = this.state.markerData[i].Recovered;
                    let recover = this.state.markerData[i].Recovered > 0 ? this.state.markerData[i].Recovered : "N/A";
                    let dead = this.state.markerData[i].Deaths;
                    let dim = this.setDim(conf);
                    // Remove Recovered Text if count does not exist
                    // if (recover > 0) {
                    //     curMarker.bindPopup(`<div class="popUpTextDiv" data-dim="${dim}"> 
                    //     <h2>${city} ${province} ${countryName} <img class='nat-view-flag' src=${flag} /> </h1> <br/> 
                    //     <h2 class="ppText text-confirmed"> Total Confirmed: ${conf.toLocaleString()}</h2> <br/> 
                    //     <h2 class="ppText text-confirmed"> Active Cases: ${active.toLocaleString()}</h2> <br/>
                    //     <h2 class="ppText text-recovered"> Recovered: ${recover.toLocaleString()} </h2> <br/>
                    //     <h2 class="ppText text-deaths"> Deaths: ${dead.toLocaleString()}</h2> </div>`, {closeButton: false}) 
                    // }
                    // else {
                    //     curMarker.bindPopup(`<div class="popUpTextDiv" data-dim="${dim}"> 
                    //     <h2>${city} ${province} ${countryName} <img class='nat-view-flag' src=${flag} /> </h1> <br/> 
                    //     <h2 class="ppText text-confirmed"> Total Confirmed: ${conf.toLocaleString()}</h2> <br/> 
                    //     <h2 class="ppText text-confirmed"> Active Cases: ${active.toLocaleString()}</h2> <br/>   
                    //     <h2 class="ppText text-deaths"> Deaths: ${dead.toLocaleString()}</h2> </div>`, {closeButton: false})
                    // }
                    curMarker.bindPopup(`<div class="popUpTextDiv" data-dim="${dim}"> 
                        <h2>${city} ${province} ${countryName} <img class='nat-view-flag' src=${flag} /> </h1> <br/> 
                        <h2 class="ppText text-confirmed"> Total Confirmed: ${conf.toLocaleString()}</h2> <br/> 
                        <h2 class="ppText text-confirmed"> Active Cases: ${active.toLocaleString()}</h2> <br/>
                        <h2 class="ppText text-recovered"> Recovered: ${recover.toLocaleString()} </h2> <br/>
                        <h2 class="ppText text-deaths"> Deaths: ${dead.toLocaleString()}</h2> </div>`, {closeButton: false})
                }
            }
        }
    }

    makerMarkerCircle = () => {
        if(this.state.globeLoaded) {
            let icons = document.getElementsByClassName('we-pm-icon');
            for(let i = 0; i < icons.length; i++) {
                let parent = icons[i].parentElement;
                let dim = parseInt(parent.childNodes[1].childNodes[0].childNodes[0].childNodes[0].dataset.dim)+'px';
                icons[i].style.display = 'none';
                parent.className = 'iconParent spinner';
                parent.style.width = dim;
                parent.style.height = dim;
                parent.id = 'iconParent-'+i;
                parent.onmouseover = () => {
                    parent.childNodes[1].style.visibility = 'visible';
                    parent.childNodes[1].style.opacity = 1;
                }
                parent.onmouseleave = () => {
                    parent.childNodes[1].style.visibility = 'hidden';
                    parent.childNodes[1].style.opacity = 0;
                }
            }
        }
    }

    // William Test 
    setDim = (count) =>  {
        if(count < 100) {
            return 5;
        }
        else if(count >= 100 && count < 1000) {
            return 11;
        }
        else if(count >= 1000 && count < 5000) {
            return 22;
        }
        else if(count >= 5000 && count < 10000) {
            return 30;
        }
        else if(count >= 10000 && count < 50000) {
            return 40;
        }
        else if(count >= 50000 && count < 100000) {
            return 48;
        }
        // else if(count > 20000 && count < 100000) {
        //     return 48;
        // }
        else if(count >= 100000 && count < 500000) {
            return 55;
        }
        else if(count >= 500000) {
            return 65;
        }
        else {
            return;
        }
    } 


    placeDummyMarker = () => {
        if(this.state.globeLoaded) { 
         

            // console.log(window);
            let marker2 = WE.marker([this.state.centre.lat, this.state.centre.long]).addTo(earth);
        

            let icons = document.getElementsByClassName('we-pm-icon');
            // console.log(icons);
            let parent1 = icons[0].parentElement;
            parent1.className = 'iconParent';
            // console.log(parent1.childNodes);
            parent1.removeChild(parent1.childNodes[0]);
            // console.log(parent1);
        }
    }

    adjustOpacity = () => {
        if(this.state.globeLoaded) {
            let opacityControl = setInterval(() => {
                let doc = document.getElementById('global-view-inner-wrapper');
                let natdoc = document.getElementById('map-right-side-national-count');
                let inp = document.getElementById('search-box');
                let lsb = document.getElementById('left-sidebar');
                let title = document.getElementById('pageTitleTxt');
                let about = document.getElementById('aboutAndTutHolder');
                let bmc = document.getElementById('bmc-btn');
                if(earth.getZoom() >=3.5) {
                    doc.style.opacity = 1;
                    natdoc ? natdoc.style.opacity = 1 : natdoc = natdoc;
                    inp ? inp.style.opacity = .2 : inp = inp;
                    pauseAnime = true;
                }
                if(earth.getZoom() < 3.5 && doc) {
                    doc.style.opacity = 1;
                    natdoc ? natdoc.style.opacity = 1 : natdoc = natdoc;
                    inp ? inp.style.opacity = 1 : inp = inp;
                    pauseAnime = false;
                }
                if(earth.getZoom() > 4 && lsb) {
                    lsb ? lsb.style.opacity = 0 : lsb = lsb;
                    title? title.style.opacity = 0 : title = title;
                    about ? about.style.opacity = 0 : about = about;
                    bmc ? bmc.style.opacity = 0 : bmc = bmc;
                }
                if(earth.getZoom() < 4 && lsb) {
                    lsb ? lsb.style.opacity = 1: lsb = lsb;
                    title ? title.style.opacity = 1: title = title;
                    about ? about.style.opacity = 1: about = about;
                    bmc ? bmc.style.opacity = 1: bmc = bmc;
                }
            }, 500)
            return () => clearInterval(opacityControl);
        }
    }

    handleCountrySearch = (event) => {
        this.setState({
            searchVal: event.target.value,
            // add '^' + for regex where search input percedes rest of word
            searchScope: event.target.value.trim().length > 0 ? Object.keys(byCountryName).filter((c) => new RegExp(event.target.value, "i").exec(c)) : []
        }, () => {
            // let doc = document.getElementById('search-box');
            // doc ? doc.placeholder = this.state.searchScope[0] : doc=doc;
        })
    }
    handleSearchResultClick = (event) => {
        let cc = byCountryName[event.target.dataset.cname].country;
        this.centralise(cc, false, true)
        this.setCurCountry(cc);
    }
    handleAboutBtnOnClick = (e) => {
        e.preventDefault();
        document.getElementById('about-modal').style.display = 'block';
    }
    
    handleTutorial = (e) => {
        e.preventDefault();
        document.getElementById('tutorial-modal').style.display = 'block';
    }
    
    handleZoomInBtnOnClick = (e) => {
        e.preventDefault();
        earth.setZoom(earth.getZoom() + .5);
    }

    handleZoomOutBtnOnClick = (e) => {
        e.preventDefault();
        earth.setZoom(earth.getZoom() - .5);
    }

    handleZoomResetBtnOnClick = () => {
        earth.setZoom(this.state.zoom);
        earth.setTilt(0);
        earth.setView([0, this.state.centre.long]);
    }
    
    
    render() {
        //4.5, 4.4        
        if(this.state.allDataLoaded && this.state.globeLoaded) {
            this.updateBoundsVariable();
            this.listenForMouseEvent(this.decideClickOrDrag, this.focusViewToCoord);
            this.adjustOpacity();
        }

        return (
            <div id="map-wrapper">
                {
                    this.state.allDataLoaded ? 
                        <div id='map-right-side-content'>
                            {
                                // this.state.curCountryClicked ? 
                                
                                this.state.curLoadedCountry ?

                                <div id='map-right-side-national-count'>
                                <h1 id='national-view-header'>{this.state.curLoadedCountry.Country} <img className='nat-view-flag' src ={flags[this.state.curLoadedCountry.CountryCode] ? flags[this.state.curLoadedCountry.CountryCode].url : ''} /></h1>
                                <h2 className='national-view-details text-confirmed'>Total Confirmed: {this.state.curLoadedCountry.TotalConfirmed.toLocaleString()}</h2>
                                <h2 className='national-view-details text-deaths'>Total Deaths: {this.state.curLoadedCountry.TotalDeaths.toLocaleString()}</h2>
                                <h2 className='national-view-details text-recovered'>Total Recovered: {this.state.curLoadedCountry.TotalRecovered.toLocaleString()}</h2>
                                </div>

                                :

                                ""

                            }
                            <GlobalView />

                        </div> 
                        : <Loader />
                }


                {
                    this.state.allDataLoaded ? 
                        <div id='left-sidebar'>
                            {
                                this.state.searchVal && this.state.searchVal.length > 0?

                                <div id='left-sidebar-search-results'>
                                    {
                                        this.state.searchScope ? this.state.searchScope.map((el, idx) => {
                                            return <span data-cname={el} key={idx+'search-item'} className='search-result-item' onClick={this.handleSearchResultClick}>{el}</span>
                                        })

                                        :

                                        ''
                                    }
                                </div>

                                :
                                
                                <SidePanel />
                            }
                        </div> 
                    : 
                ''
                }
                {this.state.allDataLoaded ? <About/> : ''}
                {this.state.allDataLoaded ? <Tutorial/> : ''}
                {
                    this.state.allDataLoaded ? 
                    <div id='bmc-btn'>
                        <a href="https://www.buymeacoffee.com/followcovid" target="_blank">
                            <img src="https://cdn.buymeacoffee.com/buttons/lato-white.png" alt="Buy Me A Coffee"/>
                        </a>
                    </div>
                    :
                    ''
                } 
                {this.state.allDataLoaded ? <input id="search-box" placeholder='Search country' value={this.searchVal} onChange={this.handleCountrySearch}/> : ''}

                {
                    this.state.allDataLoaded ?

                    <div id="aboutAndTutHolder">
                        <div id='about-me-btn' className='about-me-btn' onClick={this.handleAboutBtnOnClick}> <h3>About us</h3> </div>

                        <div id='tutorial-button' className='about-me-btn' onClick={this.handleTutorial}> <h3>Tutorial</h3> </div>
                    </div>

                    :

                    ""
                }


                {
                    this.state.allDataLoaded ?

                    <div id="zoom-btns-holder">
                        <div id='zoom-in-btn' className='zoom-in-btn ziobtns' onClick={this.handleZoomInBtnOnClick}> <h3>+</h3> </div>
                        <div id='zoom-out-btn' className='zoom-out-btn ziobtns' onClick={this.handleZoomOutBtnOnClick}> <h3>-</h3> </div>
                    </div>

                    :

                    ""
                }


                {this.state.allDataLoaded ? <div id='zoom-reset-btn' onClick={this.handleZoomResetBtnOnClick}> <h3>Zoom Reset</h3> </div> : ''}
                {this.state.allDataLoaded ? <h1 id='pageTitleTxt'>followcoronavirus.com</h1>: ''}

                <div id="earth_div">
                    
                </div>

            </div>
        )
    }
}
